<template>
  <section id="how-it-works" class="how-it-works">
    <header>
      <h2>{{ $t('home.howItWorksTitle') }}</h2>
      <p class="subtitle">{{ $t('home.howItWorksSubTitle') }}</p>
    </header>
    <div class="container">
      <div class="steps-grid">
        <div class="step-card">
          <div class="step-number">1</div>
          <h3 class="step-title">{{ $t('home.stepConnect') }}</h3>
          <p class="step-label">{{ $t('home.processLink') }}</p>
          <p class="step-desc">{{ $t('home.processLinkTip') }}</p>
        </div>
        <div class="step-connector">
          <svg width="40" height="16" viewBox="0 0 40 16" fill="none">
            <path d="M0 8h32m0 0l-6-6m6 6l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="step-card">
          <div class="step-number">2</div>
          <h3 class="step-title">{{ $t('home.stepCustomize') }}</h3>
          <p class="step-label">{{ $t('home.processEdit') }}</p>
          <p class="step-desc">{{ $t('home.processEditTip') }}</p>
        </div>
        <div class="step-connector">
          <svg width="40" height="16" viewBox="0 0 40 16" fill="none">
            <path d="M0 8h32m0 0l-6-6m6 6l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="step-card">
          <div class="step-number">3</div>
          <h3 class="step-title">{{ $t('home.stepPrint') }}</h3>
          <p class="step-label">{{ $t('home.processOrder') }}</p>
          <p class="step-desc">{{ $t('home.processOrderTip') }}</p>
        </div>
      </div>
      <div class="steps-cta">
        <button class="btn-connect" @click="showModal = true">{{ $t('home.connectNow') }} <span class="cta-arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></span></button>
      </div>
    </div>

    <!-- Social Source Modal -->
    <div class="connect-modal-mask" v-if="showModal" @click.self="showModal = false">
      <div class="connect-modal">
        <div class="connect-modal__close" @click="showModal = false">&times;</div>
        <h3 class="connect-modal__title">{{ $t('home.connectModalTitle') }}</h3>
        <div class="connect-modal__options">
          <a class="connect-option" :href="facebookLoginPath">
            <svg viewBox="0 0 24 24" fill="#1877F2" width="40" height="40">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from 'src/app.config'
export default {
  name: 'HowItWorks',
  data () {
    return {
      showModal: false,
      facebookLoginPath: config.facebookLoginPath
    }
  },
  methods: {
    selectSource (source) {
      this.showModal = false
      this.$router.push({ name: 'shelf' })
    }
  }
}
</script>

<style lang="scss">
.how-it-works {
  background-color: #f8f9fc;
  padding: 5rem 1.5rem;

  .steps-grid {
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 0;
    max-width: 960px;
    margin: 0 auto;
  }

  .step-card {
    flex: 1;
    max-width: 280px;
    text-align: center;
    padding: 2rem 1.5rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s;
    display: flex;
    flex-direction: column;

    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
  }

  .step-number {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: $el-color-primary;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.25rem;
  }

  .step-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 0.5rem;
  }

  .step-label {
    font-size: 0.9375rem;
    color: $el-color-primary;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .step-desc {
    font-size: 0.9375rem;
    color: #6b7280;
    line-height: 1.6;
    flex: 1;
  }

  .step-connector {
    display: flex;
    align-items: center;
    padding-top: 3.5rem;
    color: $el-color-primary-shadow;
    flex-shrink: 0;
  }

  .steps-cta {
    text-align: center;
    margin-top: 2.5rem;
  }

  .btn-connect {
    display: inline-block;
    padding: 0.875rem 3rem;
    background-color: $el-color-primary;
    color: #fff;
    font-size: 1.0625rem;
    font-weight: 600;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
      background: linear-gradient(to right, #F56368, #ff878b);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
    }
  }
}

/* Connect Modal */
.connect-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.connect-modal {
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  max-width: 460px;
  width: 90%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);

  &__close {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 24px;
    color: #9ca3af;
    cursor: pointer;
    line-height: 1;
    &:hover { color: #374151; }
  }

  &__title {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 2rem;
  }

  &__options {
    display: flex;
    justify-content: center;
    gap: 2rem;
  }
}

.connect-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  text-decoration: none;

  &:hover {
    border-color: $el-color-primary;
    box-shadow: 0 4px 16px rgba(81, 45, 202, 0.15);
    transform: translateY(-2px);
    text-decoration: none;
  }

  span {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
  }
}

@media (max-width: 768px) {
  .how-it-works {
    padding: 3.5rem 1rem;

    .steps-grid {
      flex-direction: column;
      align-items: center;
    }

    .step-connector {
      padding-top: 0;
      transform: rotate(90deg);
      margin: -0.5rem 0;
    }

    .step-card {
      width: 100%;
      max-width: 100%;
      padding: 1.5rem 1rem;
    }

    .steps-cta {
      margin-top: 2rem;
    }

    .btn-connect {
      width: 100%;
      max-width: 280px;
    }
  }

  .connect-modal {
    &__options {
      gap: 1rem;
    }
  }

  .connect-option {
    padding: 1rem;

    svg {
      width: 32px;
      height: 32px;
    }

    span {
      font-size: 0.8125rem;
    }
  }
}
</style>
